module.exports = __webpack_public_path__ + "static/media/rendimiento esperado-rojo_old.e46bfc39.svg";